import { Injectable } from '@angular/core';
import { User } from 'src/app/core/models/user';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  currentUser: User;
	selectedLanguage
  authentication_token
  constructor() { 
    if (localStorage.getItem('authentication_token')) {
			this.authentication_token = localStorage.getItem('authentication_token');
		}
    // console.log(this.authentication_token);
  }
}
